import React, {
  useState,
  useEffect,
} from 'react';

import computeSearchWhere from 'shared-utils/src/computeSearchWhere';
import resetFiltersOnSetLocality from 'shared-utils/src/resetFiltersOnSetLocality';

import computeSearchFilters from './utils/computeSearchFilters';


const voidLocationObj = {
  search: [],
  searchParent: {},
  ui: {
    main: null,
    additional: null,
  },
};

const setInitialLocation = (locs) => {
  const locations = locs.locations || [];
  if (locations.length === 0) {
    return voidLocationObj;
  } else {
    const { searchLocations, searchLocationsParent, uiLocations } = computeSearchWhere(locations, locs.parent);
    return {
      search: searchLocations,
      searchParent: searchLocationsParent,
      ui: uiLocations,
    }
  }
}

const SearchBuilder = ({
  initialFilters,
  initialLocations,
  fetchLocationById,
  children,
}) => {
  const [filters, setFilters] = useState(initialFilters);
  const [locations, setLocations] = useState(setInitialLocation(initialLocations));
  const [justOnce, setJustOnce] = useState(true);

  // initialFilters && initialLocations in HP arrive later since they're retrieved from localStorage
  useEffect(() => setFilters(computeSearchFilters(initialFilters, true)), [initialFilters]);
  useEffect(() => {
    if (initialLocations.locations && justOnce) {
      setLocations(setInitialLocation(initialLocations));
      setJustOnce(false);
    }
  }, [initialLocations, justOnce]);

  const setCurrentFilters = (userFilters, clb) => {
    const newFilters = computeSearchFilters(userFilters);
    setFilters(newFilters)
    clb && clb(newFilters);
  };

  const setCurrentLocation = async (userLocations, parent, filtersToKeep, clb) => {
    if (userLocations.length) {
      const isMapLocality = userLocations[0]?.level === 999;
      
      let correctParent = { ...parent };
      if (!parent && userLocations[0]?.parent?.town?.id && !isMapLocality) {
        correctParent = await fetchLocationById(userLocations[0].parent.town.id);
      }
      const { searchLocations, uiLocations } = computeSearchWhere(userLocations, correctParent);
      setLocations((state) => ({
        search: searchLocations,
        searchParent: correctParent,
        ui: {
          ...state.ui,
          ...uiLocations,
        },
      }));

      const filtersToReset = Object.keys(filtersToKeep).length > 0
        ? { ...filtersToKeep }
        : { ...filters };

      const newFilters = resetFiltersOnSetLocality(filtersToReset, isMapLocality);
      setCurrentFilters(newFilters);
      
      clb && clb(searchLocations, correctParent, newFilters);
    } else {
      setLocations(voidLocationObj);
      clb && clb(voidLocationObj.search, voidLocationObj.searchParent);
    }
  };

  const setCurrentNearby = (nearbyData, clb, nearbySearchAddress = null) => {
    const newFilters = {
      ...resetFiltersOnSetLocality(filters),
      nearby: nearbyData,
    };

    let newLocations = voidLocationObj;
    if (nearbySearchAddress) {
      const { searchLocations, uiLocations } = computeSearchWhere(nearbySearchAddress, []);
      newLocations = {
        search: searchLocations,
        searchParent: [],
        ui: {
          ...locations.ui,
          ...uiLocations,
        },
      };
    }

    setCurrentFilters(newFilters);
    setLocations(newLocations);
    clb && clb(newLocations.search, newLocations.searchParent, newFilters);
  };

  return (
    <>
      {
        children({
          filters,
          locations,
          setCurrentNearby,
          setCurrentFilters,
          setCurrentLocation,
          computeSearchFilters,
        })
      }
    </>
  );
}

export default SearchBuilder;
